import "core-js/modules/es.array.join.js";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { LeaseTypeEnum } from "./Enums";
import { formatNumber } from "./numberFormatting";
export var truncateToTwoDecimals = function truncateToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
};
export var getRateValue = function getRateValue(listing, rateTypeLabel, showBaseRate) {
  var _context;
  if (!listing) {
    return {
      value: null,
      suffix: rateTypeLabel || ""
    };
  }
  var isCoworking = listing.leaseType && _includesInstanceProperty(_context = [LeaseTypeEnum.COWORKING.value, LeaseTypeEnum.ENTERPRISE_COWORKING.value]).call(_context, listing.leaseType);
  if (isCoworking && listing.deskMonthlyRate) {
    return {
      value: listing.deskMonthlyRate,
      suffix: "Mo"
    };
  }
  var value = showBaseRate ? listing.askingRate || null : listing.allInclusiveRent || listing.askingRate || null;
  return {
    value: value,
    suffix: rateTypeLabel || ""
  };
};
export var getRate = function getRate(listing, isCoworking, deskMonthlyRate, rateTypeLabel) {
  if (!listing) return "N/A";
  if (isCoworking && deskMonthlyRate) {
    return formatNumber(deskMonthlyRate, {
      decimalCount: 2,
      displayTrailingZeros: true,
      prefix: "$",
      suffix: " /mo"
    });
  }
  var rate = listing.allInclusiveRent || listing.askingRate;
  if (!rate) return "N/A";
  return formatNumber(rate, {
    decimalCount: 2,
    displayTrailingZeros: true,
    prefix: "$",
    suffix: rateTypeLabel ? " ".concat(rateTypeLabel) : ""
  });
};
export var getCompSuiteFloorDisplay = function getCompSuiteFloorDisplay(rawFloor, rawSuite, fallback) {
  if (rawFloor || rawSuite) {
    var _context2;
    return _filterInstanceProperty(_context2 = [rawFloor, rawSuite]).call(_context2, Boolean).join(" - ");
  }
  return fallback || "";
};
export var getSpaceDisplay = function getSpaceDisplay(listing) {
  var floorDisplay = listing.floorDisplay;
  var suiteDisplay = listing.suiteDisplay;
  if (floorDisplay && suiteDisplay) {
    var _context3;
    return _concatInstanceProperty(_context3 = "".concat(floorDisplay, " - ")).call(_context3, suiteDisplay);
  } else if (floorDisplay) {
    return floorDisplay;
  } else if (suiteDisplay) {
    return suiteDisplay;
  }
  return listing.displayAddressWithFloor || "N/A";
};